import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/(auth)/_components/auth-shell.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["RegistrationForm"] */ "/vercel/path0/apps/web/app/(auth)/cadastro/registration-form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.24_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_@types_7e5dcee682bbc21bd69ce5a9d9cfed34/node_modules/next/dist/client/app-dir/link.js");
